'use strict';
const queryStringToMap = require('./query-string-to-map');
module.exports = function PopupLauncher({navigatorShim}) {
	if (!navigatorShim) {
		throw new Error('invalid-args');
	}
	const parseResponse = function (responseMessage, messagePrefix) {
			if (!responseMessage.data || !responseMessage.data.startsWith(messagePrefix)) {
				return;
			}
			if (responseMessage.origin !== navigatorShim.getOrigin()) {
				return;
			}
			const authResponse = queryStringToMap(responseMessage.data.substring(messagePrefix.length - 1));
			return authResponse;
		},
		openAndWaitForMessage = (url, messagePrefix) => {
			if (!url || !messagePrefix) {
				throw new Error('invalid-args');
			}
			const promise = new Promise((resolve) => {
				const responseReceived = function (responseMessage) {
					const response = parseResponse(responseMessage, messagePrefix);
					if (!response) {
						return;
					}
					navigatorShim.removeMessageListener(responseReceived);
					resolve(response);
				};
				navigatorShim.addMessageListener(responseReceived);
			});
			navigatorShim.popup(url);
			return promise;
		};
	Object.freeze(Object.assign(this, {openAndWaitForMessage}));
};

